<template>
  <div style="padding: 5px;">
    <a-card>
      <div style="text-align: right;">
        <span
          class="ant-descriptions-title"
          style="float: left; margin-top: 5px;"
        >
          <a-icon type="tags" /> Reminder
        </span>

        <a-button slot="extra" type="primary" @click="showDrawerAddReminder">
          <a-icon type="plus" /> Add
        </a-button>
      </div>

      <a-drawer
        v-if="visibleAddReminder"
        title="Add"
        placement="right"
        :visible="visibleAddReminder"
        @close="closeDrawerAddReminder"
        :width="450"
      >
        <AddReminder
          :closeDrawerAddReminder="closeDrawerAddReminder"
          :createdReminderOnView="createdReminderOnView"
        />
      </a-drawer>

      <a-drawer
        v-if="visibleUpdateReminder"
        title="Edit"
        placement="right"
        :visible="visibleUpdateReminder"
        @close="closeDrawerUpdateReminder"
        :width="450"
        :destroyOnClose="true"
      >
        <UpdateReminder
          :closeDrawerUpdateReminder="closeDrawerUpdateReminder"
          :updateReminderOnView="updateReminderOnView"
          :moduleName="moduleName"
          :id="id"
        />
      </a-drawer>

      <a-table
        :loading="loading"
        size="small"
        :columns="columnReminder"
        :data-source="listReminder"
        rowKey="id"
        style="margin-top: 5px;"
        :pagination="{
          current: currentPage,
          onChange: (page) => {
            this.currentPage = page;
          },
          pageSize: limit,
        }"
        :scroll="{ y: 'calc(100vh - 400px)', x: 'calc(100vw - 100px)' }"
      >
        <div slot="stt" slot-scope="text, record, index">
          {{ index + 1 }}
        </div>

        <div slot="createdAt" slot-scope="text, record">
          <p>
            {{ record.createdAt | formatDateHour }}
          </p>
        </div>

        <div slot="updatedAt" slot-scope="text, record">
          <p>
            {{ record.updatedAt | formatDateHour }}
          </p>
        </div>

        <div slot="action" slot-scope="text, record">
          <a-button
            icon="edit"
            @click="showDrawerUpdateReminder(record)"
            class="icon-update"
          >
            Edit
          </a-button>
        </div>

        <div slot="footer">
          <a-button
            :loading="loading"
            type="link"
            @click="pagination"
            :disabled="disabledButtonPagination"
          >
            <a-icon type="reload" /> Load more
          </a-button>
        </div>
      </a-table>
    </a-card>
  </div>
</template>
<script>
import debounce from "lodash/debounce";
import AddReminder from "./components/addReminder";
import UpdateReminder from "./components/updateReminder";
import getQuery from "../data/getData";
import { columnReminder } from "../Constants/dataColumns";
import {
  updateForCreated,
  updateForUpdated,
} from "@/services/updateOnViewConfig";

const limit = 10;
const startPage = 1;
export default {
  components: {
    AddReminder,
    UpdateReminder,
  },
  data() {
    this.onFilter = debounce(this.onFilter, 800);
    return {
      limit,
      moduleName: null,
      id: null,
      visibleAddReminder: false,
      visibleUpdateReminder: false,
      currentPage: startPage,
      totalPage: startPage,
      disabledButtonPagination: false,
      loading: true,
      columnReminder,
      listReminder: [],
    };
  },
  methods: {
    updateReminderOnView(item) {
      this.listReminder = updateForUpdated(this.listReminder, item);
    },
    createdReminderOnView(item) {
      this.listReminder = updateForCreated({
        list: this.listReminder,
        item,
        limit,
        currentPage: this.totalPage,
      });
    },

    showDrawerAddReminder() {
      this.visibleAddReminder = true;
    },
    closeDrawerAddReminder() {
      this.visibleAddReminder = false;
    },

    showDrawerUpdateReminder(record) {
      this.visibleUpdateReminder = true;
      this.moduleName = record.module;
      this.id = record.id;
    },
    closeDrawerUpdateReminder() {
      this.visibleUpdateReminder = false;
    },

    onFilter() {
      this.currentPage = 1;
      this.totalPage = 1;
      this.listReminder = [];
      this.getAllReminder();
    },

    pagination() {
      this.totalPage += 1;
      this.currentPage = this.totalPage;
      this.getAllReminder();
    },
    getAllReminder() {
      this.loading = true;
      this.$apollo
        .query({
          query: getQuery.getAllAppConfigReminder,
          variables: {},
        })
        .then(({ data }) => {
          if (data?.getAllAppConfigReminder?.length >= 0) {
            if (data.getAllAppConfigReminder.length < limit) {
              this.disabledButtonPagination = true;
            } else {
              this.disabledButtonPagination = false;
            }
            this.listReminder = [
              ...this.listReminder.concat(data.getAllAppConfigReminder),
            ];
          }

          this.loading = false;
        })
        .catch((error) => {
          console.log("Không lấy được danh sách cấu hình", error);
        });
    },
  },
  created() {
    this.getAllReminder();
  },
};
</script>
